import { Env, readFromEnv } from '@cinch-nx/environments'
import { stripNonSearchQueryParametersFromUrl } from '../strip-non-search-query-parameters-from-url/strip-non-search-query-parameters-from-url'

export const getUsedCarsApiRequestUrlForUrlPath = (urlPath: string) => {
  const urlWithoutLeadingSlash = urlPath.startsWith('/')
    ? urlPath.slice(1)
    : urlPath
  const urlWithNonSearchParamsRemoved = stripNonSearchQueryParametersFromUrl(
    urlWithoutLeadingSlash,
  )
  const searchServiceUrl = readFromEnv(Env.SearchServiceUrl)
  return `${searchServiceUrl}/used-cars?url=${encodeURIComponent(
    urlWithNonSearchParamsRemoved,
  )}`
}
